module.exports = __webpack_public_path__ + "static/img/lhcstc.93e55050.jpg";